/**
 *
 * VoiceServices
 *
 */
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Edit } from './Edit';

interface Props {}

export function VoiceServices(props: Props) {
  return (
    <Routes>
      <Route path={``} element={<Edit />} />
    </Routes>
  );
}
